import * as React from 'react';

export const SolarIcon = () => (
  <svg width="128" height="128" viewBox="0 0 128 128">
    <defs>
      <path d="M128 64C128 99.3 99.3 128 64 128 28.6 128 0 99.3 0 64 0 28.6 28.6 0 64 0 99.3 0 128 28.6 128 64" />
    </defs>
    <g fill="none">
      <mask fill="#fff">
        <use xlinkHref="#solar-icon-a" />
      </mask>
      <use xlinkHref="#solar-icon-a" fill="#F8F8F8" />
      <g mask="url(#solar-icon-b)">
        <g transform="translate(25 24)">
          <path
            d="M21 32.2C27.1 32.2 32.1 27.2 32.1 21 32.1 14.9 27.1 9.8 21 9.8 14.8 9.8 9.8 14.9 9.8 21 9.8 27.2 14.8 32.2 21 32.2"
            fill="#FFC72C"
          />
          <polygon points="3.3 22.6 6.5 22.6 6.5 19.4 3.3 19.4 0.1 19.4 0.1 22.6" fill="#FFC72C" />
          <polygon
            points="38.6 22.6 41.8 22.6 41.8 19.4 38.6 19.4 35.4 19.4 35.4 22.6"
            fill="#FFC736"
          />
          <polygon points="7.3 9.7 9.6 11.9 11.9 9.7 9.6 7.4 7.3 5.1 5 7.4" fill="#FFC72C" />
          <polygon
            points="32.3 34.7 34.6 36.9 36.9 34.7 34.6 32.4 32.3 30.1 30 32.4"
            fill="#FFC736"
          />
          <polygon points="19.3 3.4 19.3 6.6 22.6 6.6 22.6 3.4 22.6 0.1 19.3 0.1" fill="#FFC72C" />
          <polygon
            points="19.3 38.7 19.3 41.9 22.6 41.9 22.6 38.7 22.6 35.4 19.3 35.4"
            fill="#FFC736"
          />
          <polygon points="32.3 7.4 30 9.7 32.3 11.9 34.6 9.7 36.9 7.4 34.6 5.1" fill="#FFC72C" />
          <polygon points="7.3 32.4 5 34.7 7.3 36.9 9.6 34.7 11.9 32.4 9.6 30.1" fill="#FFC72C" />
        </g>
      </g>
      <rect width="4.2" height="17.7" x="69.8" y="84.5" mask="url(#solar-icon-b)" fill="#D2D2D1" />
      <rect width="32.1" height="4.2" x="55.9" y="98" mask="url(#solar-icon-b)" fill="#ABABAB" />
      <rect width="57.4" height="43.5" x="43.2" y="43.2" mask="url(#solar-icon-b)" fill="#D2D2D1" />
      <rect width="11.7" height="11.7" x="45.3" y="45.4" mask="url(#solar-icon-b)" fill="#0A5FD2" />
      <rect width="11.7" height="11.7" x="45.3" y="58.9" mask="url(#solar-icon-b)" fill="#0A5FD2" />
      <rect width="11.7" height="11.7" x="45.3" y="72.8" mask="url(#solar-icon-b)" fill="#0A5FD2" />
      <rect width="11.7" height="11.7" x="59.1" y="45.4" mask="url(#solar-icon-b)" fill="#0A5FD2" />
      <rect width="11.7" height="11.7" x="59.1" y="58.9" mask="url(#solar-icon-b)" fill="#0A5FD2" />
      <rect width="11.7" height="11.7" x="59.1" y="72.8" mask="url(#solar-icon-b)" fill="#0A5FD2" />
      <rect width="11.7" height="11.7" x="72.9" y="45.4" mask="url(#solar-icon-b)" fill="#0A5FD2" />
      <rect width="11.7" height="11.7" x="72.9" y="58.9" mask="url(#solar-icon-b)" fill="#0A5FD2" />
      <rect width="11.7" height="11.7" x="72.9" y="72.8" mask="url(#solar-icon-b)" fill="#0A5FD2" />
      <rect width="11.7" height="11.7" x="86.6" y="45.4" mask="url(#solar-icon-b)" fill="#0A5FD2" />
      <rect width="11.7" height="11.7" x="86.6" y="58.9" mask="url(#solar-icon-b)" fill="#0A5FD2" />
      <rect width="11.7" height="11.7" x="86.6" y="72.8" mask="url(#solar-icon-b)" fill="#0A5FD2" />
    </g>
  </svg>
);
